<template>
    <div class="login-box" v-loading.fullscreen.lock="loading">
        <!-- 头部 -->
        <PublicHead1></PublicHead1>
        <!-- 头部 -->
        <div class="login-form">
            <p>
                <label>
                    <img src="@/assets/front/icon-name.png" />用户名 ID
                </label>
                <el-input
                    v-model.trim="form.account"
                    prefix-icon="el-icon-user"
                    placeholder
                />
                <em>*</em>
            </p>
            <p>
                <label>
                    <img src="@/assets/front/icon-password.png" />密码 Password
                </label>
                <el-input
                    type="password"
                    show-password
                    v-model.trim="form.password"
                    prefix-icon="el-icon-lock"
                    :placeholder="pwdText"
                />
                <em>*</em>
            </p>
            <div class="new-password" v-if="form.type">
                <p class="password-pattern">
                    <i class="el-icon-info"></i>
                    新密码必须为大写英文、小写英文、数字、特殊字符组合的8-16位值，且不包含3位以上连续字符！
                </p>
                <p>
                    <el-input
                        type="password"
                        show-password
                        v-model.trim="form.newPassword"
                        prefix-icon="el-icon-key"
                        placeholder="新密码"
                        autocomplete="off"
                    ></el-input>
                </p>
                <p>
                    <el-input
                        type="password"
                        show-password
                        v-model.trim="form.confirmPassword"
                        prefix-icon="el-icon-key"
                        placeholder="确认密码"
                        autocomplete="off"
                    ></el-input>
                </p>
            </div>
            <p>
                <el-button
                    type="primary"
                    icon="el-icon-upload"
                    @click="login"
                    size="small"
                    >登录 <span style="margin-left: 1em">Login</span></el-button
                >
                <span class="login-msg" v-html="msg"></span>
            </p>
        </div>
        <!-- 底部 -->
        <PublicFoot></PublicFoot>
        <!-- 底部 -->
    </div>
</template>
<script>
import PublicHead1 from "@/pages/front/components/head1.vue";
import PublicFoot from "@/pages/front/components/foot.vue";
import { getToken } from "../api/main/api-user";
import { getUserType } from "../api/gm/api-user";
import { addLog } from "../api/gm/api-loginlog"; //登录日志
export default {
    data() {
        return {
            loading: false,
            form: {
                type: 0,
                account: "", // 生成环境去除赋值
                password: "", // 生成环境去除赋值
                newPassword: "",
                confirmPassword: "",
            },
            pwdText: "",
            color: "rgb(169, 169, 169)",
            msg: "*请输入账号和密码<br>*Please enter ID. and password.",
        };
    },
    components: {
        PublicHead1,
        PublicFoot,
    },
    methods: {
        login() {
            this.loading = true;
            getToken(this.form).then((res) => {
                this.loading = false;
                if (res.code === 2) {
                    // 重置密码
                    this.form.type = 1;
                    this.form.newPassword = "";
                    this.form.confirmPassword = "";
                    this.pwdText = "原始密码";
                    this.errMsg(res.msg);
                } else if (res.code === 0) {
                    this.$store.dispatch("loginAction", res.data);
                    getUserType(res.data.user.account).then((result) => {
                        //获取当前会员那类型
                        if (res.code === 0) {
                            this.$store.dispatch("usertypeAction", result.data);

                            if (result.data) {
                                //前台会员记录登录日志
                                let inp = {
                                    account: res.data.user.account,
                                    device: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
                                        navigator.userAgent
                                    )
                                        ? "手机"
                                        : "PC",
                                };
                                addLog(inp).then((logresult) => {
                                    console.dir("jieguo" + logresult);
                                });
                            }

                            if (this.$route.query.redirect) {
                                this.$router.replace(
                                    this.$route.query.redirect
                                );
                            } else {
                                if (result.data) {
                                    //前台会员
                                    this.$router.replace("/product-list");
                                } else {
                                    this.$router.replace("/control");
                                }
                            }
                        } else {
                            this.errMsg(res.msg);
                        }
                    });
                } else {
                    this.errMsg(res.msg);
                }
            });
        },
        errMsg(s) {
            this.color = "#ff7b00";
            this.msg = s;
        },
    },
};
</script>
<style lang="less" scoped>
/deep/.logout {
    display: none;
}
.login-box {
    text-align: center;
    background: url(../assets/front/icon-loginbg.png) center bottom no-repeat;
    height: 100vh;
    /deep/ .head-page {
        background-color: #eee;
    }
}
.login-form {
    margin: 11vw auto 0px;
    padding: 15px 30px;
    width: 540px;
    p {
        text-align: left;
        margin: 0px 0px 50px 0px;
        display: flex;
        align-items: center;

        label {
            font-size: 24px;
            color: #313131;
            line-height: 30px;
            margin: 0px 25px 0px 0px;
            position: relative;
            padding-left: 35px;
            display: inline-block;
            width: 110px;
            flex-shrink: 0;

            img {
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                margin: -2px 15px 0px 0px;
                vertical-align: middle;
            }
        }

        &:last-child {
            display: block;
        }

        .el-input {
            width: 375px;
            display: inline-block;

            /deep/.el-input__inner {
                width: 372px;
                height: 65px;
                background: #eeeeee;
                border: 1px solid #dcdcdc;
                line-height: 65px;
                text-indent: 1em;
                padding: 0px;
                border-radius: 0px;
            }

            /deep/.el-input__prefix {
                display: none;
            }
        }

        em {
            color: #ff0000;
            font-size: 24px;
            position: relative;
            top: 7px;
            padding-left: 8px;
        }
        .el-button {
            // width: 510px;
            width: 100%;
            height: 65px;
            background: #214d98;
            color: #fff;
            font-size: 24px;
            // letter-spacing: 15px;
            margin: 18px 0px 0px 2px;
            border-radius: 0px;
            /deep/.el-icon-upload {
                display: none;
            }
        }
    }
}
.login-msg {
    text-align: left;
    float: left;
    // width: 205px;
    min-height: 35px;
    // line-height: 35px;
    display: block;
    font-size: 14px;
    color: #ff0000;
    margin: 15px 0px 0px 0px;
}
.new-password {
    padding-top: 10px;
    .password-pattern {
        padding: 0px;
        margin: 0px;
        font-size: 12px;
        color: #409eff;
        text-align: left;
        i {
            font-size: 14px;
            &:hover {
                color: #2893fd;
            }
        }
    }
}
@media (max-width: 1400px) {
    .login-form {
        margin: 8vw auto 0px;
    }
}

@media (max-width: 1024px) {
    .login-box {
        background: url(../assets/front/icon-loginbg1.png) center bottom
            no-repeat;
    }
    .login-form {
        width: 81%;
        padding: 0px;
        margin: 22vw auto 0px;
        p {
            margin: 0px 0px 20px 0px;
            label {
                font-size: 18px;
                width: 100%;
                margin: 0px 0px 5px 0px;
                img {
                    max-width: 18px;
                    margin: -2px 10px 0px 0px;
                }
            }
            .el-input {
                width: 95%;
                display: inline-block;

                /deep/.el-input__inner {
                    width: 100%;
                    height: 45px;
                    line-height: 45px;
                }

                /deep/.el-input__prefix {
                    display: none;
                }
            }
            em {
                float: right;
                text-align: right;
                top: 14px;
            }
            .el-button {
                width: 95%;
                height: 45px;
                line-height: 45px;
                padding: 0px;
                margin: 30px 0px 0px 0px;
                font-size: 20px;
            }
            .login-msg {
                margin: 3px 0px 0px 0px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue